<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>代金券管理</h1>
        <p>一张券一个兑换码。兑换码在明细里查看。划拨只允许总部发给渠道，上级不能划给下级。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="open = true">发放代金券</button>
      </div>
    </div>
    <div class="ch-metrics">
      <div class="ch-metric"><div class="k">券张数</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">面值合计</div><div class="v">¥ {{ yuan(face) }}</div></div>
      <div class="ch-metric"><div class="k">待确认到账</div><div class="v">{{ count('PENDING_PAY') }}</div></div>
      <div class="ch-metric"><div class="k">待审批</div><div class="v">{{ count('PENDING_REVIEW') }}</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <select v-model="source">
          <option value="">发放方式：全部</option>
          <option value="PURCHASE">购买</option>
          <option value="APPLY">申请审批</option>
          <option value="GRANT">总部划拨</option>
        </select>
        <select v-model="state">
          <option value="">状态：全部</option>
          <option value="PENDING_PAY">待确认到账</option>
          <option value="PENDING_REVIEW">待审批</option>
          <option value="UNUSED">未使用</option>
          <option value="USED">已使用</option>
          <option value="EXPIRED">已过期</option>
          <option value="REJECTED">已驳回</option>
        </select>
      </div>
      <table class="ch-table">
        <thead>
          <tr>
            <th>券编号</th>
            <th>所属渠道</th>
            <th>面值</th>
            <th>发放方式</th>
            <th>状态</th>
            <th>凭证</th>
            <th>申请理由</th>
            <th>驳回原因</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in shown" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>¥ {{ yuan(row.faceValue) }}</td>
            <td>{{ statusName(row.source) }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusName(row.status) }}</span></td>
            <td>
              <button v-if="proofUrl(row)" class="proof-btn" type="button" @click="openProof(row)">
                <img v-if="isImage(row.proofUrl)" :src="proofUrl(row)" alt="凭证" />
                <span v-else>查看凭证</span>
              </button>
              <span v-else>—</span>
            </td>
            <td class="reason">{{ row.applyReason || '—' }}</td>
            <td class="reason">{{ row.rejectReason || '—' }}</td>
            <td>
              <button class="ch-link" type="button" @click="detail = row">明细</button>
              <button v-if="row.status === 'PENDING_PAY'" class="ch-link" type="button" @click="act(row, 'confirmPay')">确认到账</button>
              <button v-if="row.status === 'PENDING_REVIEW'" class="ch-link" type="button" @click="act(row, 'approve')">发放</button>
              <button v-if="row.status === 'PENDING_PAY' || row.status === 'PENDING_REVIEW'" class="ch-link" type="button" @click="act(row, 'reject')">驳回</button>
            </td>
          </tr>
          <tr v-if="!shown.length"><td colspan="9" class="ch-empty">没有代金券</td></tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="发放代金券" :visible.sync="open" width="420px">
      <el-form label-width="80px" size="small">
        <el-form-item label="渠道">
          <el-select v-model="form.partnerId" filterable>
            <el-option v-for="item in partners" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="面额(元)"><el-input v-model="form.faceValue" /></el-form-item>
        <el-form-item label="方式">
          <el-select v-model="form.source">
            <el-option label="购买" value="PURCHASE" />
            <el-option label="申请审批" value="APPLY" />
            <el-option label="总部划拨" value="GRANT" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="券明细" :visible.sync="detailOpen" width="480px">
      <div v-if="detail" class="ch-kv">
        <span>券编号</span><b>{{ detail.id }}</b>
        <span>渠道</span><b>{{ nameOf(detail.partnerId) }}</b>
        <span>面值</span><b>¥ {{ yuan(detail.faceValue) }}</b>
        <span>申请理由</span><b>{{ detail.applyReason || '—' }}</b>
        <span>驳回原因</span><b>{{ detail.rejectReason || '—' }}</b>
        <span>兑换码</span><b>{{ detail.redeemCode || '待发放' }}</b>
        <span>兑换用户</span><b>{{ detail.usedByUserId || '—' }}</b>
        <span>凭证</span>
        <b>
          <button v-if="proofUrl(detail)" class="ch-link" type="button" @click="openProof(detail)">查看凭证</button>
          <template v-else>—</template>
        </b>
      </div>
      <div v-if="detail && isImage(detail.proofUrl)" class="proof-inline" @click="openProof(detail)">
        <img :src="proofUrl(detail)" alt="凭证" />
      </div>
    </el-dialog>
    <el-dialog title="转账凭证" :visible.sync="proofOpen" width="720px" append-to-body @closed="proof = null">
      <div v-if="proof" class="proof-view">
        <img v-if="isImage(proof.proofUrl)" :src="proofUrl(proof)" alt="凭证" />
        <p v-else class="ch-empty">当前凭证不是图片，请下载后查看</p>
        <button class="ch-btn" type="button" :disabled="proofSaving" @click="downloadProof">下载凭证</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelPartners, getChannelVouchers, createChannelVoucher, reviewChannelVoucher } from '@/api/admin'
import { resolveFileUrl } from '@/utils/fileUrl'
import { statusName, yuan } from '../partner/labels'
import { partnerName } from './lookup'

export default {
  name: 'HqVouchers',
  data() {
    return {
      partners: [],
      list: [],
      source: '',
      state: '',
      open: false,
      detail: null,
      proof: null,
      proofSaving: false,
      form: { partnerId: '', faceValue: '', source: 'GRANT' }
    }
  },
  computed: {
    detailOpen: {
      get() { return !!this.detail },
      set(v) { if (!v) this.detail = null }
    },
    proofOpen: {
      get() { return !!this.proof },
      set(v) { if (!v) this.proof = null }
    },
    face() { return this.list.reduce((n, item) => n + Number(item.faceValue || 0), 0) },
    shown() {
      return this.list.filter(item => (!this.source || item.source === this.source) && (!this.state || item.status === this.state))
    }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    nameOf(id) { return partnerName(this.partners, id) },
    count(status) { return this.list.filter(item => item.status === status).length },
    tagOf(status) {
      if (status === 'UNUSED' || status === 'USED') return 'ok'
      if (status === 'EXPIRED' || status === 'REJECTED') return 'bad'
      return 'warn'
    },
    proofUrl(row) {
      return resolveFileUrl((row && row.proofUrl) || '')
    },
    isImage(url) {
      return /\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(String(url || ''))
    },
    openProof(row) {
      if (!this.proofUrl(row)) return
      this.proof = row
    },
    proofFileName(url) {
      const path = String(url || '').split('?')[0]
      const name = path.split('/').pop() || 'voucher-proof'
      if (/\.[a-z0-9]+$/i.test(name)) return name
      return name + '.jpg'
    },
    async downloadProof() {
      const url = this.proofUrl(this.proof)
      if (!url || this.proofSaving) return
      this.proofSaving = true
      const name = this.proofFileName(this.proof && this.proof.proofUrl)
      try {
        const response = await fetch(url, { mode: 'cors' })
        if (!response.ok) throw new Error('download failed')
        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(objectUrl)
      } catch (e) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.rel = 'noopener'
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } finally {
        this.proofSaving = false
      }
    },
    async load() {
      const partners = await getChannelPartners()
      const vouchers = await getChannelVouchers()
      this.partners = partners.list || []
      this.list = vouchers.list || []
    },
    async submit() {
      await createChannelVoucher(this.form)
      this.open = false
      this.$message.success('已提交')
      this.load()
    },
    async act(row, action) {
      const body = { action }
      if (action === 'reject') {
        let input
        try {
          input = await this.$prompt('驳回原因', '驳回', {
            inputPlaceholder: '请填写驳回原因，渠道商可以看到',
            inputValidator: value => (value && value.trim() ? true : '请填写驳回原因')
          })
        } catch (e) {
          return
        }
        body.reason = String(input.value || '').trim()
      }
      await reviewChannelVoucher(row.id, body)
      this.$message.success('已处理')
      this.load()
    }
  }
}
</script>

<style scoped>
.reason { max-width: 220px; white-space: pre-wrap; word-break: break-all; }
.proof-btn { border: 0; background: transparent; padding: 0; cursor: pointer; color: #2f4dbf; }
.proof-btn img { width: 56px; height: 40px; object-fit: cover; border-radius: 6px; border: 1px solid #e7ebf3; display: block; }
.proof-inline { margin-top: 12px; cursor: pointer; }
.proof-inline img { max-width: 100%; max-height: 220px; border-radius: 8px; border: 1px solid #e7ebf3; display: block; }
.proof-view { text-align: center; }
.proof-view img { max-width: 100%; max-height: 70vh; border-radius: 8px; display: block; margin: 0 auto 12px; }
.proof-view .ch-btn { display: inline-block; line-height: 34px; border: 0; cursor: pointer; }
.proof-view .ch-btn:disabled { opacity: .6; cursor: wait; }
</style>
